(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["BT-ShotBanner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const isMobile = window.innerWidth <= 600;
    if (!isMobile) return;

    const sliders = document.querySelectorAll('.coll');

    sliders.forEach((slider) => {
      const sectionId = slider.getAttribute("data-section-id");
      const track = slider.querySelector(`#slider-track-${sectionId}`);
      const slides = track.querySelectorAll(".image-2");
      const prevBtn = slider.querySelector(".prev-btn");
      const nextBtn = slider.querySelector(".next-btn");

      let currentIndex = 0;
      let interval;

      function updateSlider() {
        track.style.transform = `translateX(-${currentIndex * 100}%)`;
      }

      function nextSlide() {
        currentIndex = (currentIndex + 1) % slides.length;
        updateSlider();
      }

      function prevSlide() {
        currentIndex = (currentIndex - 1 + slides.length) % slides.length;
        updateSlider();
      }

      function startAutoplay() {
        interval = setInterval(nextSlide, 3000);
      }

      function resetAutoplay() {
        clearInterval(interval);
        startAutoplay();
      }

      nextBtn.addEventListener("click", () => {
        nextSlide();
        resetAutoplay();
      });

      prevBtn.addEventListener("click", () => {
        prevSlide();
        resetAutoplay();
      });

      updateSlider();
      startAutoplay();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["BT-Testimonial"] && !Shopify.designMode) return;
  try {
    
class PxlTestimonialsSlider extends HTMLElement {
  connectedCallback() {
    if (!document.querySelector('#pxl-swiper-script')) {
      const s = document.createElement('script')
      s.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js'
      s.id = 'pxl-swiper-script'
      document.head.appendChild(s)
      s.onload = () => this.init()
    } else if (window.Swiper) {
      this.init()
    } else {
      const wait = setInterval(() => {
        if (window.Swiper) { clearInterval(wait); this.init() }
      }, 150)
      setTimeout(() => clearInterval(wait), 8000)
    }
  }

  init() {
    if (this.swiper) return
    const partialMobile = this.dataset.partialMobile === 'true' ? 1.15 : 1
    this.swiper = new window.Swiper(this.querySelector('.pxl-testi__swiper'), {
      rewind: true,
      spaceBetween: 16,
      speed: Number(this.dataset.speed) || 350,
      watchSlidesProgress: true,
      mousewheel: { enabled: true, forceToAxis: true },
      breakpoints: {
        0:    { slidesPerView: Number(this.dataset.xs) * partialMobile, spaceBetween: 12 },
        576:  { slidesPerView: Number(this.dataset.sm) },
        768:  { slidesPerView: Number(this.dataset.md) },
        992:  { slidesPerView: Number(this.dataset.lg) },
        1200: { slidesPerView: Number(this.dataset.xl) },
        1400: { slidesPerView: Number(this.dataset.xxl) }
      },
      navigation: {
        enabled: this.dataset.nav === 'true',
        prevEl: this.querySelector('.pxl-testi__btn-prev'),
        nextEl: this.querySelector('.pxl-testi__btn-next')
      },
      pagination: {
        enabled: this.dataset.pagination === 'true',
        el: this.querySelector('.pxl-testi__pagination'),
        dynamicBullets: true,
        clickable: true
      },
      scrollbar: {
        enabled: this.dataset.scrollbar === 'true',
        el: this.querySelector('.pxl-testi__scrollbar'),
        draggable: true
      },
      autoplay: this.dataset.autoplay !== '0'
        ? { delay: Number(this.dataset.autoplay) * 1000, disableOnInteraction: false, pauseOnMouseEnter: true }
        : false
    })
  }
}
if (!customElements.get('pxl-testimonials-slider')) {
  customElements.define('pxl-testimonials-slider', PxlTestimonialsSlider)
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["BT-media-slider"] && !Shopify.designMode) return;
  try {
    
class KsMediaSlider extends HTMLElement {
  constructor () {
    super()

    if (!document.querySelector('#swiper-stylesheet')) {
      const stylesheet = document.createElement('link')
      stylesheet.setAttribute('href', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css')
      stylesheet.setAttribute('rel', 'stylesheet')
      stylesheet.setAttribute('id', 'swiper-stylesheet')
      stylesheet.setAttribute('integrity', 'sha256-5nkrwjVsiNfKz3NR1k2h5+qt5pS5SF2u9/TIT1hElow=')
      stylesheet.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(stylesheet)
    }

    if (!document.querySelector('#swiper-script')) {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js')
      script.setAttribute('id', 'swiper-script')
      script.setAttribute('integrity', 'sha256-rCACDWCp/VzIh0rsB+ipQCM9XBvO8HNe0fNSOa4sys0=')
      script.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(script)
    }

    this.myInterval = setInterval(() => {
      this.init()
    }, 500);

    document.addEventListener('shopify:section:load', () => {
      if (event.target.querySelector('.ks-media-slider')) {
        this.init()
      }
    })
  }

  init () {
    if (!window.Swiper) return

    const slider = new window.Swiper(this.querySelector('.swiper'), {
      rewind: true,
      speed: Number(this.dataset.sliderSpeed),
      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: this.dataset.sliderPaginationType,
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        }
      },
      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true
        // hide: true
      },
      autoplay: this.dataset.sliderAutoplay !== '0'
        ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
        : undefined,
      watchSlidesProgress: true, 
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
      on: {
        slideChange: (swiper) => {
          this.querySelectorAll('.swiper-slide').forEach(slide => {
            if (!slide.classList.contains('swiper-slide-visible')) {
              slide.querySelectorAll('.video').forEach(video => {
                video.pause()
              })
              slide.querySelectorAll('iframe').forEach(iframe => {
                const iframeSrc = iframe.src
                iframe.src = iframeSrc
              })
            }
          })
        }
      }
    })

    const lazyVideosObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.play()
        }
      })
    }, { rootMargin: '0px 0px 300px 0px' })
    
    this.querySelectorAll('video[data-autoplay="true"]').forEach((el) => {
      lazyVideosObserver.observe(el)
    })

    clearInterval(this.myInterval)
  }
}
customElements.define('ks-media-slider', KsMediaSlider)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
